module.exports = __webpack_public_path__ + "img/404.99ddfa77.svg";